module.exports = __webpack_public_path__ + "img/user.588c2e39.png";